import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import commonEn from './locales/en/common.json';
import walletEn from './locales/en/wallet.json';
import chatEn from './locales/en/chat.json';
import canvasEn from './locales/en/canvas.json';
import authEn from './locales/en/auth.json';
import projectsEn from './locales/en/projects.json';
import settingsEn from './locales/en/settings.json';
import dashboardEn from './locales/en/dashboard.json';
import navigationEn from './locales/en/navigation.json';
import errorsEn from './locales/en/errors.json';
import welcomeEn from './locales/en/welcome.json';
import termsEn from './locales/en/terms.json';
import kbEn from './locales/en/kb.json';
import supportEn from './locales/en/support.json';
import socialEn from './locales/en/social.json';
import onboardingEn from './locales/en/onboarding.json';
import growthEn from './locales/en/growth.json';

import commonAr from './locales/ar/common.json';
import walletAr from './locales/ar/wallet.json';
import chatAr from './locales/ar/chat.json';
import canvasAr from './locales/ar/canvas.json';
import authAr from './locales/ar/auth.json';
import projectsAr from './locales/ar/projects.json';
import settingsAr from './locales/ar/settings.json';
import dashboardAr from './locales/ar/dashboard.json';
import navigationAr from './locales/ar/navigation.json';
import errorsAr from './locales/ar/errors.json';
import welcomeAr from './locales/ar/welcome.json';
import termsAr from './locales/ar/terms.json';
import kbAr from './locales/ar/kb.json';
import supportAr from './locales/ar/support.json';
import socialAr from './locales/ar/social.json';
import onboardingAr from './locales/ar/onboarding.json';
import growthAr from './locales/ar/growth.json';

const resources = {
    en: {
        common: commonEn,
        wallet: walletEn,
        chat: chatEn,
        canvas: canvasEn,
        auth: authEn,
        projects: projectsEn,
        settings: settingsEn,
        dashboard: dashboardEn,
        navigation: navigationEn,
        errors: errorsEn,
        welcome: welcomeEn,
        terms: termsEn,
        kb: kbEn,
        support: supportEn,
        social: socialEn,
        onboarding: onboardingEn,
        growth: growthEn,
    },
    ar: {
        common: commonAr,
        wallet: walletAr,
        chat: chatAr,
        canvas: canvasAr,
        auth: authAr,
        projects: projectsAr,
        settings: settingsAr,
        dashboard: dashboardAr,
        navigation: navigationAr,
        errors: errorsAr,
        welcome: welcomeAr,
        terms: termsAr,
        kb: kbAr,
        support: supportAr,
        social: socialAr,
        onboarding: onboardingAr,
        growth: growthAr,
    },
};

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'en',
        defaultNS: 'common',
        interpolation: {
            escapeValue: false, // React already escapes
        },
        detection: {
            order: ['localStorage', 'navigator', 'htmlTag'],
            caches: ['localStorage'],
            lookupLocalStorage: 'i18nextLng',
            // Only use navigator if localStorage doesn't have a value
            checkWhitelist: true,
        },
    });

// Update document direction and font based on language
i18n.on('languageChanged', (lng) => {
    const isRTL = lng === 'ar';
    document.documentElement.lang = lng;
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    
    // Apply font family based on direction
    if (isRTL) {
        document.documentElement.style.fontFamily = '"Alexandria", sans-serif';
        document.documentElement.style.fontOpticalSizing = 'auto';
    } else {
        document.documentElement.style.fontFamily = '"Instrument Sans", sans-serif';
        document.documentElement.style.fontOpticalSizing = 'auto';
    }
});

// Set initial direction and font
const initialLang = i18n.language || 'en';
const isRTL = initialLang === 'ar';

if (isRTL) {
    document.documentElement.dir = 'rtl';
    document.documentElement.lang = 'ar';
    document.documentElement.style.fontFamily = '"Alexandria", sans-serif';
    document.documentElement.style.fontOpticalSizing = 'auto';
} else {
    document.documentElement.dir = 'ltr';
    document.documentElement.lang = 'en';
    document.documentElement.style.fontFamily = '"Instrument Sans", sans-serif';
    document.documentElement.style.fontOpticalSizing = 'auto';
}

export default i18n;

